
import { Component, Vue } from 'nuxt-property-decorator'
import SeoMetaComponent from '~/components/classes/meta'
import meta from '~/helpers/meta'
import { Articolo } from '~/types/models/Articolo'

@Component
export default class CorsiPage extends SeoMetaComponent {
  public items: Articolo[] = []
  public pagination!: any

  public head() {
    return meta(
      'Corsi',
      "Corsi organizzati dall'Associazione astagiudiziaria.com",
      this.$config.siteUrl + 'img/logo.png',
      this.$config.siteUrl + 'corsi'
    )
  }

  async fetch() {
    await this.fetchModel(this.$route.query.page || 1)
  }

  async fetchModel(page: any = 1) {
    const { data } = await this.$axios.get(
      'corsi?attivo=1&page=' + page + '&orderBy[]=data_inizio&orderBy[]=desc'
    )
    this.items = [...data.items]
    this.pagination = { ...data.pagination }
  }

  fetchOnServer() {
    return false
  }

  public getImage(item: Articolo) {
    if (!item?.assets?.length) {
      return '/img/blog-3.jpg'
    }
    const image = item.assets.find(
      (asset) => asset.assetableField === 'mainImage'
    )
    if (!image) {
      return '/img/blog-3.jpg'
    }
    return this.$config.cdnEndpoint + '512/' + image.originalName
  }
}
